<template>
  <div class="intell">
    <common-layout>
      <div slot="header">
        <h3>小兰智答</h3>
      </div>
      <div slot="container">
        <div class="hot-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addNews"
            style="background: #623AA2; border: none;"
          >
            新增
          </el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            class="input-with-select"
            @keyup.enter.native="search"
            clearable
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
          <el-button type="primary" @click="goKeyword">关键词录入</el-button>
        </div>

        <div class="hot-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="问题" prop="question" align="center"></el-table-column>
            <el-table-column label="答案" prop="answer" align="center">
              <template slot-scope="scope">
                <p class="wraper">{{ GetTarg(scope.row.answer) }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total, prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog :title="Title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="问题" prop="question">
          <el-input placeholder="请输入问题" v-model="formData.question" clearable></el-input>
        </el-form-item>
        <el-form-item label="答案" prop="answer">
          <!-- <editor style="margin-top:10px" :quill-data="formData.answer" :upload-url="uploadURL" :img-show-url="imgUrl" @getQuillData="getQuillData"></editor> -->
          <editor
            style="margin-top:10px"
            v-model="formData.answer"
            :upload-url="uploadURL"
            :img-show-url="imgUrl"
          ></editor>
        </el-form-item>
        <el-form-item style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('formData')">提交</el-button>
          <el-button @click="closeForm('formData')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
// import editor from "../../components/yhQuillEditor";
import editor from '../../components/tinymce-editor/tinymce-editor';
export default {
  components: {
    CommonLayout,
    editor
  },
  data() {
    return {
      tableData: [],
      searchValue: '',
      total: 10,
      per_page: 10,
      current_page: 1,
      dialogFormVisible: false,
      selected: '',
      Title: '',
      formData: {
        question: '',
        answer: ''
      },
      rules: {
        question: [
          {
            required: true,
            message: '请输入问题',
            trigger: 'blur'
          }
        ],
        answer: [
          {
            required: true,
            message: '请输入答案',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    this.getData('Knowledge?type=1');
  },
  methods: {
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/knowledge/page`, params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page;
        }
      });
    },
    //富文本
    getQuillData(val) {
      this.formData.answer = val;
    },
    search() {
      this.getData('Knowledge?type=1&question=' + this.searchValue);
    },
    //新增
    addNews() {
      this.Title = '新增';
      this.dialogFormVisible = true;
      this.formData = {
        question: '',
        answer: ''
      };
    },
    //编辑
    handleEdit(val) {
      this.Title = '编辑';
      this.dialogFormVisible = true;
      this.formData = JSON.parse(JSON.stringify(val));
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.formData));
          obj.type = 1;
          if (!obj.id) {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/knowledge/create`, obj).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功');
                this.getData('Knowledge?type=1');
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            });
          } else {
            // delete obj.id;
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/knowledge/update` , obj).then(res => {
              if (res.code == 0) {
                this.$message.success('编辑成功');
                this.getData('Knowledge?type=1');
                this.dialogFormVisible = false;
                this.$refs[formName].resetFields();
              } else {
                this.$message.error(res.status);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //关闭
    closeForm(formName) {
      this.dialogFormVisible = false;
      this.$refs[formName].resetFields();
    },
    //批量删除
    deleteAll() {
      if (this.selected) {
        this.$confirm('确定删除文件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/knowledge/batchDelete?ids=` + this.selected, '', 'delete').then(response => {
              if (response.code == 0) {
                this.$message.success('删除成功！');
                this.getData('Knowledge?type=1');
              }
            });
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的文件'
        });
      }
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/knowledge/delete?id=` + row.id, '', 'delete').then(res => {
            if (res.code == 0) {
              this.getData('Knowledge?type=1');
              this.$message({
                type: 'success',
                message: '删除成功'
              });
            } else {
              this.$message({
                message: '失败！',
                type: 'error'
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //选择行数
    selectionChange(sec) {
      let ids = '';
      for (let i of sec) {
        ids += i.id + ',';
      }
      ids = ids.substr(0, ids.length - 1);
      this.selected = ids;
    },
    //翻页
    handleCurrentChange(val) {
      this.getData('Knowledge?type=1&page=' + val);
    },
    //上传图片
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage(files, e, 'HouImg');
    },
    //其他图片上传
    createImage(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        width: 960
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64
            })
            .then(res => {
              this.formData.image = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },

    handlePictureCardPreview(file) {
      this.formData.image = file.data.store_result;
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    deleteImg() {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.formData.image = '';
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    goKeyword() {
      this.$router.push({
        path: '/serviceIntelligence/keyword'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@include component(intell) {
  width: 100%;
  height: 100%;

  .hot-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  .hot-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }

  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 200px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
  /deep/ .yh-quill-editor {
    .el-upload {
      display: none;
    }

    .ql-toolbar {
      text-align: left;
    }
  }
}
</style>
